import { SchemeType } from "@foxone/api/src/models/defi";

export const ERROR = {
  HAS_UNPAID_ORDER: 203003,
  HAS_UNCOMPELTE_WITHDRAW: 204002
};

export const ProductTypes = [
  // SchemeType.CURRENT,
  // SchemeType.TERM,
  SchemeType.NODE,
  SchemeType.POOL,
  SchemeType.DUAL_NODE
];
